import { render, staticRenderFns } from "./IdentityInfo.vue?vue&type=template&id=7d6e4cba&scoped=true&"
import script from "./IdentityInfo.vue?vue&type=script&lang=js&"
export * from "./IdentityInfo.vue?vue&type=script&lang=js&"
import style0 from "./IdentityInfo.vue?vue&type=style&index=0&id=7d6e4cba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6e4cba",
  null
  
)

export default component.exports